<template>
  <div>{{ result }}</div>
</template>

<script>
export default {
  data() {
    return {
      result: '设置失败'
    }
  },
  mounted() {
    this.$http.defaults.baseURL = 'http://' + this.$route.params.baseUrl + '/'
    this.result = '设置成功'
  }
}
</script>

<style>
</style>
